import { Pipe, PipeTransform } from "@angular/core";
import { getDefaultGroupNameKey } from "@app/_helpers/utils";
import { TranslateService } from "@ngx-translate/core";
import { GroupDefaults } from "@timeghost/web-api";

const defaults = {
	[GroupDefaults.adminGroupId]: "admin",
	[GroupDefaults.everyoneGroupId]: "everyone",
};
@Pipe({
	name: "groupTranslate",
	pure: false,
})
export class GroupTranslatePipe implements PipeTransform {
	constructor(private translate: TranslateService) {}
	transform(value: string, id: string): string {
		if (defaults[id]) return this.translate.instant("workspace.groups.type." + defaults[id]);
		const translationKey = getDefaultGroupNameKey(id);
		if (translationKey) return this.translate.instant(translationKey);
		return value;
	}
}
